import API from '@/api';
const Allergy = API.get('Allergy');
const User = API.get('User');

export default ({
  namespaced: true,
  state: {
    id: null,
    allergy: '',
    note: '',
    // type: '',
    allergies: [],
    active: null,
    activeIndex: null,
    deleted_items: []
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    allergy: state => state.allergy,
    note: state => state.note,
    // type: state => state.type,
    allergies: state => state.allergies,
    active: state => state.active,
    activeIndex: state => state.activeIndex,
    deleted_items: state => state.deleted_items
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    updateAllergy(state, allergy) {
      state.allergy = allergy
    },
    updateNote(state, note) {
      state.note = note
    },
    
    /* ################################################## METHOD SEPARATORS ################################################## */

    add(state) {
      var allergy = {
        id: null,
        allergy: state.allergy,
        note: state.note,
        // type: state.type
      }
      state.allergies.push(allergy)
      console.log('ALLERGIES LIST', state.allergies)
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clear(state) {
      state.id = null
      state.allergy = ''
      state.note = ''
      // state.type = ''
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    edit(state) {
      var allergy = {
        id: state.id,
        allergy: state.allergy,
        note: state.note,
        // type: state.type
      }
      state.allergies.splice(state.activeIndex, 1, allergy);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setActive(state, index) {
      var allergy = state.allergies[index];
      state.id = allergy.id
      state.allergy = allergy.allergy
      state.note = allergy.note
      // state.type = allergy.type
      state.activeIndex = index;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    remove(state) {
      console.log('addToDeletedItems')
      if (state.allergies[state.activeIndex].id) {
        state.deleted_items.push(state.allergies[state.activeIndex].id)
      }
      console.log('remove')
      state.allergies.splice(state.activeIndex, 1);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    pushNewAllergy(state, allergy) {
      state.allergies.push(allergy);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clearStoreData(state) {
      state.id = null
      state.allergy = '';
      state.note = '';
      // state.type = '';
      state.allergies = [];
      state.active = null;
      state.activeIndex = null;
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async save({ getters, dispatch }, {user_id, patient_info_id}) {
      getters.allergies.forEach(async allergy => {
        const payload = {
          allergy: allergy.allergy,
          note: allergy.note
        }
        let response;
        if (allergy.id == null) {
          payload.type = "allergy",
          payload.patient_information_id = patient_info_id,
          payload.user_id = user_id

          console.log("[allergy/payload ]", payload);

          response = await Allergy.create(payload);
          console.log("[allergy/save]", response, allergy.allergy);
        }
        else {
          response = await Allergy.update(allergy.id, payload);
          console.log("[allergy/update]", response, allergy.allergy, allergy.id);
        }
        dispatch('deleteRemoved', {root: true})
      });
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async compiled_allergies({ getters }, { patient_info_id}) {
      
      let compiled_allergies = [];

      getters.allergies.forEach(async allergy => {
        const payload = {
          allergy: allergy.allergy,
          note: allergy.note,
          patient_information_id: patient_info_id,
        }

        compiled_allergies.push(payload);
      });

      return compiled_allergies;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async deleteRemoved({getters}) {
      console.log('deleteRemoved')
      if (getters.deleted_items.length) {
        getters.deleted_items.forEach(async id => {
          let response = await Allergy.delete(id);
          console.log("[allergy/deleteRemoved]", response);
        });
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async delete(state, id) {
      var user = await User.get(id)
      var allergies = user.data.allergies
      console.log('ALLERGIES TO BE DELETED', allergies)
      if (allergies) {
        allergies.forEach(async allergy => {
          let response = await Allergy.delete(allergy.id);
          console.log("[allergy/delete]", response);
        });
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async loadSavedData(state, id) {
      var user = await User.get(id)
      var allergies = user.data.allergies
      if (allergies !== null && allergies !== undefined) {
        allergies.forEach(async allergy => {
          const data = {
            id: allergy.id,
            allergy: allergy.allergy,
            note: allergy.note,
            // type: allergy.type
          }
          state.commit('pushNewAllergy', data)
        });
      }
    },
  }
})